import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchDependenciesOver = async ({ queryKey }) => {
  const [, tcid] = queryKey;

  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found");

  const user = JSON.parse(userDetails);

  if (!tcid) return [];

  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}`, {
    params: {
      action: "getDependenciesOver",
      testcaseid: tcid,
      companyid: user.companyid,
    },
  });

  return response.data;
};

const useDependenciesOverQuery = (tcid) => {
  return useQuery({
    queryKey: ["dependenciesOver", tcid],
    queryFn: fetchDependenciesOver,
    enabled: !!tcid, // 🔥 auto fetch like your tc-names hook
  });
};

export default useDependenciesOverQuery;
